import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Label,
} from "recharts";
import * as GraphAPI from "../api/graph-api";
import { format, addHours } from "date-fns";
import frLocale from "date-fns/locale/fr";
import { WithTranslationLangProps } from "../utils/i18next/with-translation-keys";
import { withTranslation } from "react-i18next";
import { toStringWithPad } from "../api/api-utils"

interface IGraphOrigDestPerHourProps extends WithTranslationLangProps {
  dataKeysDef?: { key: string; label: string }[];
  perHourData?: GraphAPI.GraphODPerHourData[];
}

class GraphOrigDestPerHour extends React.Component<IGraphOrigDestPerHourProps> {
  private getAxisValueLabel(dataObj: GraphAPI.GraphODPerHourData): string {
    const startHour = format(dataObj.hour, "HH", { locale: frLocale });
    const endHour = format(addHours(dataObj.hour, 1), "HH", { locale: frLocale });
    return `[${startHour}h-${endHour}h[`;
  }

  render() {
    if (this.props.perHourData && this.props.dataKeysDef)
      return (
        <>
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={this.props.perHourData}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis dataKey={this.getAxisValueLabel} />
              <YAxis
                width={50}
                domain={[
                  (dataMin: any) => Math.max(0, Math.floor(dataMin) - 3),
                  100,
                ]}
              >
                <Label
                  angle={-90}
                  value={this.props.t("chart_legend_reliability")}
                  position="insideLeft"
                  style={{ textAnchor: "middle" }}
                />
              </YAxis>
              <Tooltip
                formatter={(value, _name, _props) =>
                  Number(value).toFixed(2) + "%"
                }
                labelFormatter={(label) => {
                  const hourLabel = label.slice(1, 3);
                  return `Trajets à départ programmé entre ${hourLabel}h et ${toStringWithPad(Number(hourLabel) + 1)}h`;
                }}
              />
              <Legend wrapperStyle={{ position: "relative", bottom: "35px" }} />
              <Line
                type="monotone"
                dataKey={this.props.dataKeysDef[0].key}
                name={this.props.dataKeysDef[0].label}
                stroke="#24356d"
                strokeWidth={2}
              />
              <Line
                type="monotone"
                dataKey={this.props.dataKeysDef[1].key}
                name={this.props.dataKeysDef[1].label}
                stroke="#9cc5c4"
                strokeWidth={2}
                strokeDasharray="5 2"
                dot={false}
              />
            </LineChart>
          </ResponsiveContainer>
        </>
      );
  }
}

export default withTranslation()(GraphOrigDestPerHour);
